import { render, staticRenderFns } from "./FornecedorWFDetalheQualidade.vue?vue&type=template&id=34b86f82&"
import script from "./FornecedorWFDetalheQualidade.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalheQualidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports